import React from "react";
import {Button, Modal} from "antd";
import {FileExcelOutlined} from "@ant-design/icons";

export const SubCompanyInvoiceButtonWrapper = ({
    showNetsisButton,
    pendingInvoiceCount = 0,
    sending,
    onSend,
    exporting,
    onExport
}) => {
    const handleSendClick = () =>
        Modal.confirm({
            title: "Faturaları Netsis'e Gönder",
            content: `Toplam ${pendingInvoiceCount} faturayı Netsis'e göndermek üzeresiniz. Onaylıyor musunuz?`,
            okText: "Evet",
            cancelText: "Hayır",
            onOk: onSend
        });

    return (
        <div style={{display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 16}}>
            <Button icon={<FileExcelOutlined />} loading={exporting} onClick={onExport}>
                Excel'e Aktar
            </Button>
            {showNetsisButton && (
                <Button
                    type="primary"
                    loading={sending}
                    disabled={!pendingInvoiceCount}
                    onClick={handleSendClick}
                >
                    Faturaları Netsis'e Gönder ({pendingInvoiceCount})
                </Button>
            )}
        </div>
    );
};
